// Auto-generated by backend/generate_daily_reminders.py — Daily Umrah reminder presets (11 languages).
export const DAILY_PRESETS = [
  {
    "id": "pagi",
    "time": "05:30",
    "url": "/pagi-petang",
    "icon": "Sun",
    "title": {
      "id": "Zikir Pagi",
      "en": "Morning Dhikr",
      "ar": "أذكار الصباح",
      "fr": "Dhikr du Matin",
      "de": "Morgen-Dhikr",
      "es": "Dhikr de la Mañana",
      "ru": "Утренний зикр",
      "zh": "晨间迪克尔",
      "ja": "朝のズィクル",
      "ko": "아침 지크르",
      "hi": "प्रातःकालीन ज़िक्र"
    },
    "hint": {
      "id": "Setelah Subuh hingga terbit matahari",
      "en": "After Fajr until sunrise",
      "ar": "بعد الفجر حتى طلوع الشمس",
      "fr": "Après le Fajr jusqu'au lever du soleil",
      "de": "Nach dem Fajr bis zum Sonnenaufgang",
      "es": "Después del Fajr hasta el amanecer",
      "ru": "После Фаджра до восхода солнца",
      "zh": "晨礼后至日出",
      "ja": "ファジュルの後、日の出まで",
      "ko": "파즈르 후 일출까지",
      "hi": "फज्र के बाद सूर्योदय तक"
    },
    "body": {
      "id": "Waktunya zikir pagi — mulailah hari dengan mengingat Allah.",
      "en": "It is time for morning Dhikr — begin your day by remembering Allah.",
      "ar": "حان وقت أذكار الصباح — ابدأ يومك بذكر الله.",
      "fr": "C'est l'heure du Dhikr du matin — commencez votre journée en vous souvenant d'Allah.",
      "de": "Es ist Zeit für den Morgen-Dhikr — beginne deinen Tag mit dem Gedenken an Allah.",
      "es": "Es hora del Dhikr de la mañana — comienza tu día recordando a Allah.",
      "ru": "Время утреннего зикра — начни свой день с поминания Аллаха.",
      "zh": "晨间迪克尔时刻到了——以记念安拉开始新的一天。",
      "ja": "朝のズィクルの時間です — アッラーへの記念とともに一日を始めましょう。",
      "ko": "아침 지크르의 시간입니다 — 알라를 기억하며 하루를 시작하세요.",
      "hi": "प्रातःकालीन ज़िक्र का समय है — अल्लाह को याद करते हुए अपना दिन शुरू करें।"
    }
  },
  {
    "id": "petang",
    "time": "17:30",
    "url": "/pagi-petang",
    "icon": "Moon",
    "title": {
      "id": "Zikir Petang",
      "en": "Evening Dhikr",
      "ar": "أذكار المساء",
      "fr": "Dhikr du Soir",
      "de": "Abend-Dhikr",
      "es": "Dhikr de la Tarde",
      "ru": "Вечерний зикр",
      "zh": "暮间迪克尔",
      "ja": "夕べのズィクル",
      "ko": "저녁 지크르",
      "hi": "सायंकालीन ज़िक्र"
    },
    "hint": {
      "id": "Setelah Ashar hingga Maghrib",
      "en": "After Asr until Maghrib",
      "ar": "بعد العصر حتى المغرب",
      "fr": "Après l'Asr jusqu'au Maghrib",
      "de": "Nach dem Asr bis zum Maghrib",
      "es": "Después del Asr hasta el Maghrib",
      "ru": "После Аср до Магриба",
      "zh": "晡礼后至昏礼",
      "ja": "アスルの後、マグリブまで",
      "ko": "아스르 후 마그립까지",
      "hi": "अस्र के बाद मग़रिब तक"
    },
    "body": {
      "id": "Waktunya zikir petang — tutup hari dengan mengingat Allah.",
      "en": "It is time for evening Dhikr — close your day by remembering Allah.",
      "ar": "حان وقت أذكار المساء — اختم يومك بذكر الله.",
      "fr": "C'est l'heure du Dhikr du soir — terminez votre journée en vous souvenant d'Allah.",
      "de": "Es ist Zeit für den Abend-Dhikr — beschließe deinen Tag mit dem Gedenken an Allah.",
      "es": "Es hora del Dhikr de la tarde — cierra tu día recordando a Allah.",
      "ru": "Время вечернего зикра — заверши свой день поминанием Аллаха.",
      "zh": "暮间迪克尔时刻到了——以记念安拉结束这一天。",
      "ja": "夕べのズィクルの時間です — アッラーへの記念とともに一日を締めくくりましょう。",
      "ko": "저녁 지크르의 시간입니다 — 알라를 기억하며 하루를 마무리하세요.",
      "hi": "सायंकालीन ज़िक्र का समय है — अल्लाह को याद करते हुए अपना दिन समाप्त करें।"
    }
  },
  {
    "id": "tawaf",
    "time": "21:00",
    "url": "/umrah-mandiri",
    "icon": "Compass",
    "title": {
      "id": "Tawaf / Umrah Sunnah",
      "en": "Tawaf / Sunnah Umrah",
      "ar": "الطواف / العمرة السنة",
      "fr": "Tawaf / Umrah Sunnah",
      "de": "Tawaf / Sunnah-Umrah",
      "es": "Tawaf / Umrah Sunnah",
      "ru": "Таваф / Сунна Умра",
      "zh": "绕行天房（Tawaf）/ 逊奈小朝（Umrah Sunnah）",
      "ja": "タワーフ（Tawaf）/ スンナのウムラ（Umrah Sunnah）",
      "ko": "타와프(Tawaf) / 순나 우므라(Umrah Sunnah)",
      "hi": "तवाफ / सुन्नत उमरह"
    },
    "hint": {
      "id": "Malam hari saat Masjidil Haram lebih lengang",
      "en": "At night when Masjidil Haram is less crowded",
      "ar": "في الليل حين تكون المسجد الحرام أقل ازدحاماً",
      "fr": "La nuit quand la Masjidil Haram est moins bondée",
      "de": "Nachts, wenn die Masjidil Haram weniger überfüllt ist",
      "es": "Por la noche cuando la Masjidil Haram está menos concurrida",
      "ru": "Ночью, когда Масджид аль-Харам менее многолюден",
      "zh": "夜间麦斯吉德·哈拉姆（Masjidil Haram）人流较少时",
      "ja": "夜間、マスジドゥル・ハラーム（Masjidil Haram）が比較的空いている時間",
      "ko": "밤에 마스지딜 하람(Masjidil Haram)이 덜 붐빌 때",
      "hi": "रात के समय जब मस्जिदुल हराम (Masjidil Haram) में कम भीड़ होती है"
    },
    "body": {
      "id": "Waktunya menuju Masjidil Haram untuk tawaf atau umrah sunnah.",
      "en": "It is time to head to Masjidil Haram for Tawaf or Sunnah Umrah.",
      "ar": "حان الوقت للتوجه إلى المسجد الحرام للطواف أو العمرة السنة.",
      "fr": "Il est temps de se diriger vers la Masjidil Haram pour le Tawaf ou l'Umrah Sunnah.",
      "de": "Es ist Zeit, zur Masjidil Haram für den Tawaf oder die Sunnah-Umrah aufzubrechen.",
      "es": "Es el momento de dirigirse a la Masjidil Haram para el Tawaf o la Umrah Sunnah.",
      "ru": "Настало время направиться в Масджид аль-Харам для совершения Таваф или Сунна Умры.",
      "zh": "现在是前往麦斯吉德·哈拉姆（Masjidil Haram）进行塔瓦夫（Tawaf）或逊奈小朝（Umrah Sunnah）的时候了。",
      "ja": "マスジドゥル・ハラーム（Masjidil Haram）へタワーフ（Tawaf）またはスンナのウムラ（Umrah Sunnah）のために向かう時間です。",
      "ko": "타와프(Tawaf) 또는 순나 우므라(Umrah Sunnah)를 위해 마스지딜 하람(Masjidil Haram)으로 향할 시간입니다.",
      "hi": "तवाफ (Tawaf) या सुन्नत उमरह (Umrah Sunnah) के लिए मस्जिदुल हराम (Masjidil Haram) जाने का समय हो गया है।"
    }
  },
  {
    "id": "tahajud",
    "time": "03:30",
    "url": "/sunnah",
    "icon": "Stars",
    "title": {
      "id": "Tahajud / Qiyamul Lail",
      "en": "Tahajud / Qiyamul Lail",
      "ar": "التهجد / قيام الليل",
      "fr": "Tahajud / Qiyamul Lail",
      "de": "Tahajud / Qiyamul Lail",
      "es": "Tahajud / Qiyamul Lail",
      "ru": "Тахаджуд / Кыямул-Лайл",
      "zh": "塔哈朱德（Tahajud）/ 夜间礼拜（Qiyamul Lail）",
      "ja": "タハッジュド（Tahajud）/ キヤームル・ライル（Qiyamul Lail）",
      "ko": "타하주드(Tahajud) / 끼야물 라일(Qiyamul Lail)",
      "hi": "तहज्जुद (Tahajud) / क़ियामुल लैल (Qiyamul Lail)"
    },
    "hint": {
      "id": "Sepertiga malam terakhir",
      "en": "The last third of the night",
      "ar": "الثلث الأخير من الليل",
      "fr": "Le dernier tiers de la nuit",
      "de": "Das letzte Drittel der Nacht",
      "es": "El último tercio de la noche",
      "ru": "Последняя треть ночи",
      "zh": "夜晚的最后三分之一",
      "ja": "夜の最後の三分の一",
      "ko": "밤의 마지막 3분의 1",
      "hi": "रात का अंतिम तीसरा पहर"
    },
    "body": {
      "id": "Bangunlah untuk qiyamul lail — sepertiga malam terakhir penuh keberkahan.",
      "en": "Arise for Qiyamul Lail — the last third of the night is filled with blessings.",
      "ar": "قُمْ لقيام الليل — الثلث الأخير من الليل مليء بالبركات.",
      "fr": "Levez-vous pour le Qiyamul Lail — le dernier tiers de la nuit est plein de bénédictions.",
      "de": "Stehe für Qiyamul Lail auf — das letzte Drittel der Nacht ist voller Segnungen.",
      "es": "Levántate para el Qiyamul Lail — el último tercio de la noche está lleno de bendiciones.",
      "ru": "Встань для Кыямул-Лайл — последняя треть ночи наполнена благодатью.",
      "zh": "起身进行夜间礼拜（Qiyamul Lail）——夜晚的最后三分之一充满了祝福与恩典。",
      "ja": "キヤームル・ライル（Qiyamul Lail）のために起き上がりましょう — 夜の最後の三分の一は祝福に満ちています。",
      "ko": "끼야물 라일(Qiyamul Lail)을 위해 일어나십시오 — 밤의 마지막 3분의 1은 축복으로 가득합니다.",
      "hi": "क़ियामुल लैल (Qiyamul Lail) के लिए उठें — रात का अंतिम तीसरा पहर बरकतों से भरा हुआ है।"
    }
  },
  {
    "id": "tilawah",
    "time": "05:45",
    "url": "/quran",
    "icon": "BookOpen",
    "title": {
      "id": "Tilawah Al-Quran",
      "en": "Tilawah Al-Qur'an",
      "ar": "تلاوة القرآن",
      "fr": "Récitation du Coran",
      "de": "Tilawah des Korans",
      "es": "Tilawah del Corán",
      "ru": "Тилава Корана",
      "zh": "诵读古兰经（提拉瓦）",
      "ja": "クルアーン朗誦（ティラーワ）",
      "ko": "꾸란 낭독 (틸라와)",
      "hi": "तिलावत अल-क़ुरआन"
    },
    "hint": {
      "id": "Setelah Subuh",
      "en": "After Fajr",
      "ar": "بعد صلاة الفجر",
      "fr": "Après le Fajr",
      "de": "Nach dem Fajr",
      "es": "Después del Fajr",
      "ru": "После Фаджра",
      "zh": "晨礼（法吉尔）后",
      "ja": "ファジュルの後",
      "ko": "파즈르 후",
      "hi": "फज्र के बाद"
    },
    "body": {
      "id": "Waktunya tilawah Al-Quran — satu juz sehari, insya Allah khatam di Tanah Suci.",
      "en": "Time for Tilawah Al-Qur'an — one juz' a day, insha'Allah completed in the Holy Land.",
      "ar": "حان وقت تلاوة القرآن الكريم — جزءٌ واحد كل يوم، وبإذن الله تُختم في الأراضي المقدسة.",
      "fr": "C'est l'heure de la récitation du Coran — un juz' par jour, qu'Allah le veuille, achevé en Terre Sainte.",
      "de": "Zeit für die Tilawah des Korans — ein Juz' täglich, insha'Allah abgeschlossen im Heiligen Land.",
      "es": "Es hora de la Tilawah del Corán — un juz' al día, insha'Allah completado en la Tierra Santa.",
      "ru": "Время Тилавы Корана — один джуз' в день, иншааллах завершим на Священной земле.",
      "zh": "诵读古兰经的时间到了——每天一个\"朱兹\"，求真主意欲，在圣地完成封印。",
      "ja": "クルアーン朗誦（ティラーワ）の時間です――インシャーアッラー、聖地で一日一ジュズ'を読み、ハタムを達成しましょう。",
      "ko": "꾸란 낭독(틸라와) 시간입니다 — 하루 한 주즈씩, 인샤알라 성지에서 완독하세요.",
      "hi": "क़ुरआन की तिलावत का वक्त है — रोज़ एक जुज़, इन्शाअल्लाह पवित्र भूमि में खत्म होगा।"
    }
  }
];

export const DAILY_UI = {
  "cardTitle": {
    "id": "Pengingat Umrah Harian",
    "en": "Daily Umrah Reminders",
    "ar": "تنبيهات العمرة اليومية",
    "fr": "Rappels quotidiens d'Omra",
    "de": "Tägliche Umrah-Erinnerungen",
    "es": "Recordatorios diarios de Umrah",
    "ru": "Ежедневные напоминания об Умре",
    "zh": "每日副朝（乌姆拉）提醒",
    "ja": "日々のウムラリマインダー",
    "ko": "일일 우므라 알림",
    "hi": "दैनिक उमरा रिमाइंडर"
  },
  "cardHint": {
    "id": "Pilih amalan dan atur jamnya. Notifikasi mengikuti waktu HP Anda dan otomatis menyesuaikan saat tiba di Makkah.",
    "en": "Choose your practices and set the time. Notifications follow your phone's time and automatically adjust when you arrive in Makkah.",
    "ar": "اختَر الأعمال وحدِّد وقتها. ستتبع الإشعارات توقيت هاتفك وتتكيَّف تلقائيًا عند وصولك إلى مكة المكرمة.",
    "fr": "Choisissez vos pratiques et définissez l'heure. Les notifications suivent l'heure de votre téléphone et s'ajustent automatiquement à votre arrivée à La Mecque.",
    "de": "Wähle deine Praktiken und stelle die Uhrzeit ein. Benachrichtigungen folgen der Uhrzeit deines Handys und passen sich automatisch an, wenn du in Makkah ankommst.",
    "es": "Elige tus prácticas y configura la hora. Las notificaciones siguen la hora de tu teléfono y se ajustan automáticamente al llegar a La Meca.",
    "ru": "Выберите практики и установите время. Уведомления следуют времени вашего телефона и автоматически подстраиваются по прибытии в Мекку.",
    "zh": "选择功修并设定时间。通知将跟随您手机的时间，抵达麦加后自动调整。",
    "ja": "実践する礼拝・アマルを選び、時間を設定してください。通知はお使いの端末の時刻に従い、マッカ到着後は自動的に調整されます。",
    "ko": "실천할 아말을 선택하고 시간을 설정하세요. 알림은 휴대폰 시간을 따르며 마카에 도착하면 자동으로 조정됩니다.",
    "hi": "अपने अमल चुनें और समय सेट करें। नोटिफिकेशन आपके फ़ोन के समय के अनुसार चलेंगी और मक्का पहुँचने पर अपने आप समायोजित हो जाएंगी।"
  },
  "timeLabel": {
    "id": "Jam",
    "en": "Time",
    "ar": "الوقت",
    "fr": "Heure",
    "de": "Uhrzeit",
    "es": "Hora",
    "ru": "Время",
    "zh": "时间",
    "ja": "時刻",
    "ko": "시간",
    "hi": "समय"
  },
  "localTime": {
    "id": "Waktu lokal HP",
    "en": "Local device time",
    "ar": "التوقيت المحلي للجهاز",
    "fr": "Heure locale de l'appareil",
    "de": "Lokale Gerätezeit",
    "es": "Hora local del dispositivo",
    "ru": "Местное время устройства",
    "zh": "设备本地时间",
    "ja": "デバイスのローカル時刻",
    "ko": "기기 현지 시간",
    "hi": "डिवाइस का स्थानीय समय"
  },
  "enabledCount": {
    "id": "{n} pengingat aktif",
    "en": "{n} reminder(s) active",
    "ar": "{n} تذكير نشط",
    "fr": "{n} rappel(s) actif(s)",
    "de": "{n} Erinnerung(en) aktiv",
    "es": "{n} recordatorio(s) activo(s)",
    "ru": "{n} напоминание(й) активно",
    "zh": "{n} 个提醒已启用",
    "ja": "{n} 件のリマインダーが有効",
    "ko": "{n}개의 알림 활성화됨",
    "hi": "{n} रिमाइंडर सक्रिय"
  },
  "none": {
    "id": "Belum ada pengingat aktif",
    "en": "No active reminders yet",
    "ar": "لا توجد تذكيرات نشطة بعد",
    "fr": "Aucun rappel actif pour l'instant",
    "de": "Noch keine aktiven Erinnerungen",
    "es": "Aún no hay recordatorios activos",
    "ru": "Активных напоминаний пока нет",
    "zh": "暂无活动提醒",
    "ja": "有効なリマインダーはまだありません",
    "ko": "아직 활성화된 알림이 없습니다",
    "hi": "अभी कोई सक्रिय रिमाइंडर नहीं है"
  },
  "manage": {
    "id": "Atur pengingat",
    "en": "Manage reminders",
    "ar": "إدارة التذكيرات",
    "fr": "Gérer les rappels",
    "de": "Erinnerungen verwalten",
    "es": "Administrar recordatorios",
    "ru": "Управление напоминаниями",
    "zh": "管理提醒",
    "ja": "リマインダーを管理する",
    "ko": "알림 관리",
    "hi": "रिमाइंडर प्रबंधित करें"
  },
  "toastOn": {
    "id": "Pengingat {title} aktif pukul {time}",
    "en": "Reminder {title} active at {time}",
    "ar": "التذكير {title} نشط في تمام الساعة {time}",
    "fr": "Rappel {title} activé à {time}",
    "de": "Erinnerung {title} aktiv um {time} Uhr",
    "es": "Recordatorio {title} activo a las {time}",
    "ru": "Напоминание {title} активно в {time}",
    "zh": "提醒 {title} 已于 {time} 启用",
    "ja": "リマインダー {title} が {time} に有効になりました",
    "ko": "알림 {title} 이(가) {time}에 활성화되었습니다",
    "hi": "रिमाइंडर {title} {time} बजे सक्रिय है"
  },
  "toastOff": {
    "id": "Pengingat {title} dimatikan",
    "en": "Reminder {title} has been turned off",
    "ar": "تم إيقاف التذكير {title}",
    "fr": "Rappel {title} désactivé",
    "de": "Erinnerung {title} wurde deaktiviert",
    "es": "Recordatorio {title} desactivado",
    "ru": "Напоминание {title} отключено",
    "zh": "提醒 {title} 已关闭",
    "ja": "リマインダー {title} がオフになりました",
    "ko": "알림 {title} 이(가) 비활성화되었습니다",
    "hi": "रिमाइंडर {title} बंद कर दिया गया है"
  },
  "pushUnavailable": {
    "id": "Notifikasi tidak tersedia di perangkat ini — pengingat tersimpan dan akan aktif di perangkat yang mendukung.",
    "en": "Notifications are not available on this device — reminders are saved and will be active on supported devices.",
    "ar": "الإشعارات غير متاحة على هذا الجهاز — تم حفظ التذكيرات وستكون نشطة على الأجهزة المدعومة.",
    "fr": "Les notifications ne sont pas disponibles sur cet appareil — les rappels sont enregistrés et seront actifs sur les appareils pris en charge.",
    "de": "Benachrichtigungen sind auf diesem Gerät nicht verfügbar — Erinnerungen werden gespeichert und sind auf unterstützten Geräten aktiv.",
    "es": "Las notificaciones no están disponibles en este dispositivo — los recordatorios están guardados y estarán activos en los dispositivos compatibles.",
    "ru": "Уведомления недоступны на этом устройстве — напоминания сохранены и будут активны на поддерживаемых устройствах.",
    "zh": "此设备不支持通知——提醒已保存，将在支持的设备上生效。",
    "ja": "このデバイスでは通知が利用できません。リマインダーは保存されており、対応デバイスで有効になります。",
    "ko": "이 기기에서는 알림을 사용할 수 없습니다 — 알림은 저장되었으며 지원되는 기기에서 활성화됩니다.",
    "hi": "इस डिवाइस पर सूचनाएं उपलब्ध नहीं हैं — रिमाइंडर सहेजे गए हैं और समर्थित डिवाइस पर सक्रिय होंगे।"
  },
  "profileTitle": {
    "id": "Pengingat Harian",
    "en": "Daily Reminders",
    "ar": "التذكيرات اليومية",
    "fr": "Rappels quotidiens",
    "de": "Tägliche Erinnerungen",
    "es": "Recordatorios diarios",
    "ru": "Ежедневные напоминания",
    "zh": "每日提醒",
    "ja": "毎日のリマインダー",
    "ko": "매일 알림",
    "hi": "दैनिक अनुस्मारक"
  },
  "daily": {
    "id": "Setiap hari",
    "en": "Every day",
    "ar": "كل يوم",
    "fr": "Chaque jour",
    "de": "Jeden Tag",
    "es": "Cada día",
    "ru": "Каждый день",
    "zh": "每天",
    "ja": "毎日",
    "ko": "매일",
    "hi": "हर दिन"
  },
  "markDone": {
    "id": "Tandai selesai hari ini",
    "en": "Mark as done today",
    "ar": "ضع علامة منجز اليوم",
    "fr": "Marquer comme accompli aujourd'hui",
    "de": "Heute als erledigt markieren",
    "es": "Marcar como hecho hoy",
    "ru": "Отметить как выполнено сегодня",
    "zh": "标记为今日已完成",
    "ja": "今日完了としてマークする",
    "ko": "오늘 완료로 표시",
    "hi": "आज पूर्ण के रूप में चिह्नित करें"
  },
  "doneToday": {
    "id": "Selesai hari ini ✔",
    "en": "Done today ✔",
    "ar": "منجز اليوم ✔",
    "fr": "Accompli aujourd'hui ✔",
    "de": "Heute erledigt ✔",
    "es": "Hecho hoy ✔",
    "ru": "Выполнено сегодня ✔",
    "zh": "今日已完成 ✔",
    "ja": "今日完了 ✔",
    "ko": "오늘 완료 ✔",
    "hi": "आज पूर्ण ✔"
  },
  "undoDone": {
    "id": "Batalkan tanda selesai",
    "en": "Undo mark as done",
    "ar": "إلغاء علامة المنجز",
    "fr": "Annuler la marque d'accompli",
    "de": "Erledigt-Markierung rückgängig machen",
    "es": "Deshacer marca como hecho",
    "ru": "Отменить отметку выполнено",
    "zh": "撤销完成标记",
    "ja": "完了マークを取り消す",
    "ko": "완료 표시 취소",
    "hi": "पूर्ण चिह्न को पूर्ववत करें"
  },
  "doneToast": {
    "id": "{title} tercatat selesai hari ini",
    "en": "{title} recorded as done today",
    "ar": "تم تسجيل {title} منجزًا اليوم",
    "fr": "{title} enregistré comme accompli aujourd'hui",
    "de": "{title} wurde heute als erledigt gespeichert",
    "es": "{title} registrado como hecho hoy",
    "ru": "{title} отмечено как выполненное сегодня",
    "zh": "{title} 已记录为今日完成",
    "ja": "{title} が今日完了として記録されました",
    "ko": "{title} 이(가) 오늘 완료로 기록되었습니다",
    "hi": "{title} आज पूर्ण के रूप में दर्ज किया गया"
  },
  "addCustom": {
    "id": "Tambah pengingat",
    "en": "Add reminder",
    "ar": "أضف تذكيرًا",
    "fr": "Ajouter un rappel",
    "de": "Erinnerung hinzufügen",
    "es": "Agregar recordatorio",
    "ru": "Добавить напоминание",
    "zh": "添加提醒",
    "ja": "リマインダーを追加する",
    "ko": "알림 추가",
    "hi": "अनुस्मारक जोड़ें"
  },
  "customTitle": {
    "id": "Judul pengingat",
    "en": "Reminder title",
    "ar": "عنوان التذكير",
    "fr": "Titre du rappel",
    "de": "Titel der Erinnerung",
    "es": "Título del recordatorio",
    "ru": "Заголовок напоминания",
    "zh": "提醒标题",
    "ja": "リマインダーのタイトル",
    "ko": "알림 제목",
    "hi": "अनुस्मारक का शीर्षक"
  },
  "customTitlePh": {
    "id": "mis. Sedekah Subuh",
    "en": "e.g. Fajr Charity",
    "ar": "مثال: صدقة الفجر",
    "fr": "ex. Aumône du Fajr",
    "de": "z.B. Fajr-Almosen",
    "es": "ej. Caridad del Fajr",
    "ru": "напр. Садака Фаджр",
    "zh": "例：晨礼施舍",
    "ja": "例：ファジュルのサダカ",
    "ko": "예: 파즈르 자선",
    "hi": "उदा. फज्र सदका"
  },
  "customBody": {
    "id": "Waktunya {title}.",
    "en": "It's time for {title}.",
    "ar": "حان وقت {title}.",
    "fr": "C'est l'heure de {title}.",
    "de": "Es ist Zeit für {title}.",
    "es": "Es hora de {title}.",
    "ru": "Пришло время для {title}.",
    "zh": "是时候{title}了。",
    "ja": "{title}の時間です。",
    "ko": "{title}할 시간입니다.",
    "hi": "{title} का समय हो गया है।"
  },
  "customHint": {
    "id": "Pengingat kustom · setiap hari",
    "en": "Custom reminder · every day",
    "ar": "تذكير مخصص · كل يوم",
    "fr": "Rappel personnalisé · chaque jour",
    "de": "Benutzerdefinierte Erinnerung · täglich",
    "es": "Recordatorio personalizado · cada día",
    "ru": "Пользовательское напоминание · каждый день",
    "zh": "自定义提醒 · 每天",
    "ja": "カスタムリマインダー · 毎日",
    "ko": "맞춤 알림 · 매일",
    "hi": "कस्टम अनुस्मारक · हर दिन"
  },
  "save": {
    "id": "Simpan",
    "en": "Save",
    "ar": "حفظ",
    "fr": "Enregistrer",
    "de": "Speichern",
    "es": "Guardar",
    "ru": "Сохранить",
    "zh": "保存",
    "ja": "保存",
    "ko": "저장",
    "hi": "सहेजें"
  },
  "cancel": {
    "id": "Batal",
    "en": "Cancel",
    "ar": "إلغاء",
    "fr": "Annuler",
    "de": "Abbrechen",
    "es": "Cancelar",
    "ru": "Отмена",
    "zh": "取消",
    "ja": "キャンセル",
    "ko": "취소",
    "hi": "रद्द करें"
  },
  "delete": {
    "id": "Hapus",
    "en": "Delete",
    "ar": "حذف",
    "fr": "Supprimer",
    "de": "Löschen",
    "es": "Eliminar",
    "ru": "Удалить",
    "zh": "删除",
    "ja": "削除",
    "ko": "삭제",
    "hi": "हटाएं"
  },
  "customAdded": {
    "id": "Pengingat \"{title}\" ditambahkan",
    "en": "Reminder \"{title}\" added",
    "ar": "تمت إضافة التذكير \"{title}\"",
    "fr": "Rappel \"{title}\" ajouté",
    "de": "Erinnerung \"{title}\" hinzugefügt",
    "es": "Recordatorio \"{title}\" añadido",
    "ru": "Напоминание \"{title}\" добавлено",
    "zh": "提醒\"{title}\"已添加",
    "ja": "リマインダー「{title}」が追加されました",
    "ko": "알림 \"{title}\"이(가) 추가되었습니다",
    "hi": "अनुस्मारक \"{title}\" जोड़ा गया"
  },
  "customDeleted": {
    "id": "Pengingat \"{title}\" dihapus",
    "en": "Reminder \"{title}\" deleted",
    "ar": "تم حذف التذكير \"{title}\"",
    "fr": "Rappel \"{title}\" supprimé",
    "de": "Erinnerung \"{title}\" gelöscht",
    "es": "Recordatorio \"{title}\" eliminado",
    "ru": "Напоминание \"{title}\" удалено",
    "zh": "提醒\"{title}\"已删除",
    "ja": "リマインダー「{title}」が削除されました",
    "ko": "알림 \"{title}\"이(가) 삭제되었습니다",
    "hi": "अनुस्मारक \"{title}\" हटाया गया"
  },
  "doneTitle": {
    "id": "{title} hari ini selesai ✔",
    "en": "{title} completed today ✔",
    "ar": "تم إتمام {title} اليوم ✔",
    "fr": "{title} accompli aujourd'hui ✔",
    "de": "{title} heute abgeschlossen ✔",
    "es": "{title} completado hoy ✔",
    "ru": "{title} выполнено сегодня ✔",
    "zh": "{title} 今日已完成 ✔",
    "ja": "{title} 本日完了 ✔",
    "ko": "{title} 오늘 완료 ✔",
    "hi": "{title} आज पूरा हुआ ✔"
  },
  "streakLine": {
    "id": "Hari ke-{n} berturut-turut",
    "en": "Day {n} in a row",
    "ar": "اليوم {n} على التوالي",
    "fr": "Jour {n} consécutif",
    "de": "Tag {n} in Folge",
    "es": "Día {n} consecutivo",
    "ru": "День {n} подряд",
    "zh": "连续第 {n} 天",
    "ja": "{n} 日連続",
    "ko": "{n}일 연속",
    "hi": "लगातार {n}वाँ दिन"
  },
  "shareBtn": {
    "id": "Bagikan",
    "en": "Share",
    "ar": "مشاركة",
    "fr": "Partager",
    "de": "Teilen",
    "es": "Compartir",
    "ru": "Поделиться",
    "zh": "分享",
    "ja": "シェア",
    "ko": "공유",
    "hi": "साझा करें"
  },
  "saveBtn": {
    "id": "Simpan gambar",
    "en": "Save image",
    "ar": "حفظ الصورة",
    "fr": "Enregistrer l'image",
    "de": "Bild speichern",
    "es": "Guardar imagen",
    "ru": "Сохранить изображение",
    "zh": "保存图片",
    "ja": "画像を保存",
    "ko": "이미지 저장",
    "hi": "छवि सहेजें"
  },
  "doneShareText": {
    "id": "Alhamdulillah, {title} hari ini selesai ✔ ({date}) — {streak}. Semoga Allah menerima amal kita.",
    "en": "Alhamdulillah, {title} completed today ✔ ({date}) — {streak}. May Allah accept our deeds.",
    "ar": "الحمد لله، {title} مكتمل اليوم ✔ ({date}) — {streak}. تقبَّل الله منَّا ومنكم.",
    "fr": "Alhamdulillah, {title} accompli aujourd'hui ✔ ({date}) — {streak}. Qu'Allah accepte nos actes d'adoration.",
    "de": "Alhamdulillah, {title} heute abgeschlossen ✔ ({date}) — {streak}. Möge Allah unsere Taten annehmen.",
    "es": "Alhamdulillah, {title} completado hoy ✔ ({date}) — {streak}. Que Allah acepte nuestras obras.",
    "ru": "Альхамдулиллах, {title} выполнено сегодня ✔ ({date}) — {streak}. Да примет Аллах наши деяния.",
    "zh": "赞主超绝，{title} 今日完成 ✔ ({date}) — {streak}。愿安拉接受我们的善功。",
    "ja": "アルハムドゥリッラー、{title} 本日完了 ✔ ({date}) — {streak}。アッラーが私たちの行いを受け入れてくださいますように。",
    "ko": "알함두릴라, {title} 오늘 완료 ✔ ({date}) — {streak}. 알라께서 우리의 행위를 받아들여 주시길 바랍니다.",
    "hi": "अलहम्दुलिल्लाह, {title} आज पूरा हुआ ✔ ({date}) — {streak}। अल्लाह हमारे अमल को क़बूल फ़रमाए।"
  },
  "cardReady": {
    "id": "Kartu selesai siap dibagikan",
    "en": "Card ready to share",
    "ar": "البطاقة جاهزة للمشاركة",
    "fr": "Carte prête à être partagée",
    "de": "Karte zum Teilen bereit",
    "es": "Tarjeta lista para compartir",
    "ru": "Карточка готова к отправке",
    "zh": "卡片已准备好分享",
    "ja": "カードの共有準備が整いました",
    "ko": "카드 공유 준비 완료",
    "hi": "कार्ड साझा करने के लिए तैयार है"
  },
  "statsTitle": {
    "id": "Statistik Ibadah",
    "en": "Worship Statistics",
    "ar": "إحصائيات العبادة",
    "fr": "Statistiques d'adoration",
    "de": "Gottesdienst-Statistiken",
    "es": "Estadísticas de adoración",
    "ru": "Статистика поклонения",
    "zh": "功课统计",
    "ja": "礼拝統計",
    "ko": "예배 통계",
    "hi": "इबादत के आँकड़े"
  },
  "statsHint": {
    "id": "7 hari terakhir — amalan yang tuntas dari pengingat harian",
    "en": "Last 7 days — completed acts of worship from daily reminders",
    "ar": "آخر ٧ أيام — العبادات المكتملة من التذكيرات اليومية",
    "fr": "7 derniers jours — actes d'adoration accomplis depuis les rappels quotidiens",
    "de": "Letzte 7 Tage — abgeschlossene Gottesdienste aus täglichen Erinnerungen",
    "es": "Últimos 7 días — actos de adoración completados desde los recordatorios diarios",
    "ru": "Последние 7 дней — завершённые акты поклонения из ежедневных напоминаний",
    "zh": "最近 7 天 — 来自每日提醒的已完成功课",
    "ja": "直近7日間 — 毎日のリマインダーから完了した礼拝",
    "ko": "최근 7일 — 매일 알림에서 완료된 예배 행위",
    "hi": "पिछले 7 दिन — दैनिक अनुस्मारक से पूर्ण की गई इबादतें"
  },
  "thisWeek": {
    "id": "Tuntas minggu ini",
    "en": "Completed this week",
    "ar": "مكتمل هذا الأسبوع",
    "fr": "Accompli cette semaine",
    "de": "Diese Woche abgeschlossen",
    "es": "Completado esta semana",
    "ru": "Выполнено на этой неделе",
    "zh": "本周已完成",
    "ja": "今週の完了数",
    "ko": "이번 주 완료",
    "hi": "इस सप्ताह पूर्ण हुआ"
  },
  "currentStreak": {
    "id": "Streak saat ini",
    "en": "Current streak",
    "ar": "السلسلة الحالية",
    "fr": "Série en cours",
    "de": "Aktuelle Serie",
    "es": "Racha actual",
    "ru": "Текущая серия",
    "zh": "当前连续天数",
    "ja": "現在のストリーク",
    "ko": "현재 연속 기록",
    "hi": "वर्तमान स्ट्रीक"
  },
  "bestStreak": {
    "id": "Streak terbaik",
    "en": "Best Streak",
    "ar": "أفضل سلسلة متتالية",
    "fr": "Meilleure série",
    "de": "Beste Serie",
    "es": "Mejor racha",
    "ru": "Лучшая серия",
    "zh": "最佳连续记录",
    "ja": "ベストストリーク",
    "ko": "최고 연속 기록",
    "hi": "सर्वश्रेष्ठ स्ट्रीक"
  },
  "days": {
    "id": "{n} hari",
    "en": "{n} day(s)",
    "ar": "{n} يوم",
    "fr": "{n} jour(s)",
    "de": "{n} Tag(e)",
    "es": "{n} día(s)",
    "ru": "{n} день(дней)",
    "zh": "{n} 天",
    "ja": "{n} 日",
    "ko": "{n} 일",
    "hi": "{n} दिन"
  },
  "noStats": {
    "id": "Belum ada catatan — tuntaskan zikir atau tandai amalan selesai untuk mulai mengisi grafik.",
    "en": "No records yet — complete a dhikr or mark a practice as done to start filling the chart.",
    "ar": "لا توجد سجلات بعد — أتمم ذكرًا أو ضع علامة اكتمال على عمل ما لبدء ملء الرسم البياني.",
    "fr": "Aucun enregistrement pour l'instant — terminez un dhikr ou marquez une pratique comme accomplie pour commencer à remplir le graphique.",
    "de": "Noch keine Einträge — schließe einen Dhikr ab oder markiere eine Praxis als erledigt, um das Diagramm zu befüllen.",
    "es": "Aún no hay registros — completa un dhikr o marca una práctica como realizada para comenzar a llenar el gráfico.",
    "ru": "Записей пока нет — завершите зикр или отметьте практику как выполненную, чтобы начать заполнять график.",
    "zh": "暂无记录——完成一次迪克尔或将功课标记为已完成，即可开始填充图表。",
    "ja": "まだ記録がありません — ズィクルを完了するか、アマルを完了済みにしてグラフを埋め始めましょう。",
    "ko": "아직 기록이 없습니다 — 디크르를 완료하거나 실천 항목을 완료로 표시하여 그래프를 채워보세요.",
    "hi": "अभी तक कोई रिकॉर्ड नहीं — चार्ट भरना शुरू करने के लिए कोई ज़िक्र पूरा करें या किसी अमल को पूर्ण के रूप में चिह्नित करें।"
  },
  "other": {
    "id": "Kustom",
    "en": "Custom",
    "ar": "مخصص",
    "fr": "Personnalisé",
    "de": "Benutzerdefiniert",
    "es": "Personalizado",
    "ru": "Пользовательский",
    "zh": "自定义",
    "ja": "カスタム",
    "ko": "사용자 정의",
    "hi": "कस्टम"
  },
  "customLabel": {
    "id": "Pengingat kustom",
    "en": "Custom Reminder",
    "ar": "تذكير مخصص",
    "fr": "Rappel personnalisé",
    "de": "Benutzerdefinierte Erinnerung",
    "es": "Recordatorio personalizado",
    "ru": "Пользовательское напоминание",
    "zh": "自定义提醒",
    "ja": "カスタムリマインダー",
    "ko": "사용자 지정 알림",
    "hi": "कस्टम रिमाइंडर"
  },
  "daysLabel": {
    "id": "Hari pengingat",
    "en": "Reminder Days",
    "ar": "أيام التذكير",
    "fr": "Jours de rappel",
    "de": "Erinnerungstage",
    "es": "Días de recordatorio",
    "ru": "Дни напоминания",
    "zh": "提醒日期",
    "ja": "リマインダーの曜日",
    "ko": "알림 요일",
    "hi": "रिमाइंडर के दिन"
  },
  "minOneDay": {
    "id": "Pilih minimal satu hari",
    "en": "Please select at least one day",
    "ar": "يرجى اختيار يوم واحد على الأقل",
    "fr": "Veuillez sélectionner au moins un jour",
    "de": "Bitte wählen Sie mindestens einen Tag aus",
    "es": "Por favor, seleccione al menos un día",
    "ru": "Пожалуйста, выберите хотя бы один день",
    "zh": "请至少选择一天",
    "ja": "少なくとも1日を選択してください",
    "ko": "최소 하루를 선택해 주세요",
    "hi": "कृपया कम से कम एक दिन चुनें"
  },
  "range7": {
    "id": "7 hari",
    "en": "7 Days",
    "ar": "٧ أيام",
    "fr": "7 jours",
    "de": "7 Tage",
    "es": "7 días",
    "ru": "7 дней",
    "zh": "7天",
    "ja": "7日間",
    "ko": "7일",
    "hi": "7 दिन"
  },
  "range30": {
    "id": "30 hari",
    "en": "30 Days",
    "ar": "٣٠ يومًا",
    "fr": "30 jours",
    "de": "30 Tage",
    "es": "30 días",
    "ru": "30 дней",
    "zh": "30天",
    "ja": "30日間",
    "ko": "30일",
    "hi": "30 दिन"
  },
  "statsHint30": {
    "id": "30 hari terakhir — amalan yang tuntas dari pengingat harian",
    "en": "Last 30 days — completed practices from daily reminders",
    "ar": "آخر ٣٠ يومًا — الأعمال المكتملة من التذكيرات اليومية",
    "fr": "30 derniers jours — pratiques accomplies depuis les rappels quotidiens",
    "de": "Letzte 30 Tage — abgeschlossene Praktiken aus täglichen Erinnerungen",
    "es": "Últimos 30 días — prácticas completadas desde los recordatorios diarios",
    "ru": "Последние 30 дней — завершённые практики из ежедневных напоминаний",
    "zh": "过去30天——来自每日提醒的已完成功课",
    "ja": "過去30日間 — 毎日のリマインダーから完了した実践",
    "ko": "최근 30일 — 매일 알림에서 완료된 실천 사항",
    "hi": "पिछले 30 दिन — दैनिक रिमाइंडर से पूर्ण किए गए अमल"
  },
  "last30": {
    "id": "Tuntas 30 hari",
    "en": "Completed in 30 Days",
    "ar": "مكتمل خلال 30 يومًا",
    "fr": "Complété en 30 jours",
    "de": "In 30 Tagen abgeschlossen",
    "es": "Completado en 30 días",
    "ru": "Выполнено за 30 дней",
    "zh": "30天内完成",
    "ja": "30日間で完了",
    "ko": "30일 완료",
    "hi": "30 दिनों में पूर्ण"
  },
  "heatTitle": {
    "id": "Kalender Konsistensi",
    "en": "Consistency Calendar",
    "ar": "تقويم الاتساق",
    "fr": "Calendrier de Cohérence",
    "de": "Konsistenz-Kalender",
    "es": "Calendario de Consistencia",
    "ru": "Календарь Последовательности",
    "zh": "坚持日历",
    "ja": "継続カレンダー",
    "ko": "꾸준함 캘린더",
    "hi": "निरंतरता कैलेंडर"
  },
  "heatHint": {
    "id": "Warna lebih pekat = lebih banyak amalan tuntas hari itu",
    "en": "Darker color = more deeds completed that day",
    "ar": "اللون الأغمق = عدد أكبر من الأعمال المكتملة في ذلك اليوم",
    "fr": "Couleur plus foncée = plus d'actes accomplis ce jour-là",
    "de": "Dunklere Farbe = mehr Taten an diesem Tag abgeschlossen",
    "es": "Color más oscuro = más actos completados ese día",
    "ru": "Более тёмный цвет = больше амалей выполнено в тот день",
    "zh": "颜色越深 = 当天完成的功课越多",
    "ja": "色が濃いほど = その日に完了した行いが多い",
    "ko": "색이 짙을수록 = 그날 완료한 실천이 많음",
    "hi": "गहरा रंग = उस दिन अधिक अमल पूर्ण हुए"
  },
  "activeDays": {
    "id": "{n} hari aktif",
    "en": "{n} active days",
    "ar": "{n} أيام نشطة",
    "fr": "{n} jours actifs",
    "de": "{n} aktive Tage",
    "es": "{n} días activos",
    "ru": "{n} активных дней",
    "zh": "{n} 个活跃天数",
    "ja": "{n} 日間アクティブ",
    "ko": "{n} 활성 일수",
    "hi": "{n} सक्रिय दिन"
  },
  "deeds": {
    "id": "{n} amalan",
    "en": "{n} deeds",
    "ar": "{n} أعمال",
    "fr": "{n} actes",
    "de": "{n} Taten",
    "es": "{n} actos",
    "ru": "{n} амалей",
    "zh": "{n} 个功课",
    "ja": "{n} 件の行い",
    "ko": "{n} 개의 실천",
    "hi": "{n} अमल"
  },
  "less": {
    "id": "Sedikit",
    "en": "Less",
    "ar": "أقل",
    "fr": "Moins",
    "de": "Weniger",
    "es": "Menos",
    "ru": "Меньше",
    "zh": "较少",
    "ja": "少ない",
    "ko": "적음",
    "hi": "कम"
  },
  "more": {
    "id": "Banyak",
    "en": "More",
    "ar": "المزيد",
    "fr": "Plus",
    "de": "Mehr",
    "es": "Más",
    "ru": "Ещё",
    "zh": "更多",
    "ja": "もっと見る",
    "ko": "더 보기",
    "hi": "अधिक"
  },
  "noDeeds": {
    "id": "Tidak ada amalan tercatat",
    "en": "No deeds recorded",
    "ar": "لا توجد أعمال مسجّلة",
    "fr": "Aucune action enregistrée",
    "de": "Keine Taten aufgezeichnet",
    "es": "No hay acciones registradas",
    "ru": "Нет записанных деяний",
    "zh": "暂无记录的功课",
    "ja": "記録された行いはありません",
    "ko": "기록된 행위가 없습니다",
    "hi": "कोई अमल दर्ज नहीं"
  },
  "prevMonth": {
    "id": "Bulan sebelumnya",
    "en": "Previous month",
    "ar": "الشهر السابق",
    "fr": "Mois précédent",
    "de": "Vorheriger Monat",
    "es": "Mes anterior",
    "ru": "Предыдущий месяц",
    "zh": "上个月",
    "ja": "前の月",
    "ko": "이전 달",
    "hi": "पिछला महीना"
  },
  "nextMonth": {
    "id": "Bulan berikutnya",
    "en": "Next month",
    "ar": "الشهر التالي",
    "fr": "Mois suivant",
    "de": "Nächster Monat",
    "es": "Mes siguiente",
    "ru": "Следующий месяц",
    "zh": "下个月",
    "ja": "次の月",
    "ko": "다음 달",
    "hi": "अगला महीना"
  },
  "badgesTitle": {
    "id": "Lencana Konsistensi",
    "en": "Consistency Badges",
    "ar": "شارات الاستمرارية",
    "fr": "Badges de constance",
    "de": "Beständigkeitsabzeichen",
    "es": "Insignias de constancia",
    "ru": "Значки постоянства",
    "zh": "坚持徽章",
    "ja": "継続バッジ",
    "ko": "꾸준함 배지",
    "hi": "निरंतरता बैज"
  },
  "badgesHint": {
    "id": "Diraih otomatis saat Anda beribadah beberapa hari berturut-turut",
    "en": "Earned automatically when you worship for several consecutive days",
    "ar": "تُمنح تلقائيًا عند عبادتك لعدة أيام متتالية",
    "fr": "Obtenu automatiquement lorsque vous adorez Allah plusieurs jours consécutifs",
    "de": "Wird automatisch vergeben, wenn Sie mehrere Tage hintereinander Gottesdienst leisten",
    "es": "Se obtiene automáticamente al adorar durante varios días consecutivos",
    "ru": "Присваивается автоматически при совершении поклонения несколько дней подряд",
    "zh": "连续数天进行功课后自动获得",
    "ja": "数日間連続して礼拝を行うと自動的に獲得されます",
    "ko": "며칠 연속으로 예배를 드리면 자동으로 획득됩니다",
    "hi": "कई लगातार दिनों तक इबादत करने पर स्वतः प्राप्त होता है"
  },
  "badgeName": {
    "id": "Lencana {n} Hari",
    "en": "{n}-Day Badge",
    "ar": "شارة {n} أيام",
    "fr": "Badge {n} Jours",
    "de": "{n}-Tage-Abzeichen",
    "es": "Insignia de {n} Días",
    "ru": "Значок «{n} дней»",
    "zh": "{n} 天徽章",
    "ja": "{n}日バッジ",
    "ko": "{n}일 배지",
    "hi": "{n} दिन का बैज"
  },
  "badgeDesc": {
    "id": "{n} hari berturut-turut beribadah",
    "en": "{n} consecutive days of worship",
    "ar": "{n} أيام متتالية من العبادة",
    "fr": "{n} jours consécutifs d'adoration",
    "de": "{n} aufeinanderfolgende Tage der Anbetung",
    "es": "{n} días consecutivos de adoración",
    "ru": "{n} дней непрерывного поклонения",
    "zh": "连续 {n} 天礼拜",
    "ja": "{n}日連続の礼拝",
    "ko": "{n}일 연속 예배",
    "hi": "{n} लगातार दिनों की इबादत"
  },
  "badgeEarnedOn": {
    "id": "Diraih {date}",
    "en": "Earned on {date}",
    "ar": "تم الحصول عليها في {date}",
    "fr": "Obtenu le {date}",
    "de": "Erreicht am {date}",
    "es": "Obtenida el {date}",
    "ru": "Получено {date}",
    "zh": "于 {date} 获得",
    "ja": "{date} に獲得",
    "ko": "{date}에 획득",
    "hi": "{date} को प्राप्त हुआ"
  },
  "badgeLocked": {
    "id": "Terkunci · {cur}/{n} hari",
    "en": "Locked · {cur}/{n} days",
    "ar": "مقفل · {cur}/{n} أيام",
    "fr": "Verrouillé · {cur}/{n} jours",
    "de": "Gesperrt · {cur}/{n} Tage",
    "es": "Bloqueado · {cur}/{n} días",
    "ru": "Заблокировано · {cur}/{n} дней",
    "zh": "已锁定 · {cur}/{n} 天",
    "ja": "ロック中 · {cur}/{n}日",
    "ko": "잠김 · {cur}/{n}일",
    "hi": "लॉक्ड · {cur}/{n} दिन"
  },
  "badgeUnlocked": {
    "id": "Masya Allah! Lencana {n} Hari diraih",
    "en": "Masha Allah! {n}-Day Badge earned",
    "ar": "ما شاء الله! تم الحصول على شارة {n} أيام",
    "fr": "Masha Allah ! Badge {n} Jours obtenu",
    "de": "Mascha Allah! {n}-Tage-Abzeichen erreicht",
    "es": "¡Masha Allah! Insignia de {n} Días obtenida",
    "ru": "Ма шаа Аллах! Значок «{n} дней» получен",
    "zh": "mashAllah！已获得 {n} 天徽章",
    "ja": "マーシャーアッラー！{n}日バッジを獲得しました",
    "ko": "마샤 알라! {n}일 배지 획득",
    "hi": "माशा अल्लाह! {n} दिन का बैज प्राप्त हुआ"
  },
  "badgeCongrats": {
    "id": "Anda telah beribadah {n} hari berturut-turut. Semoga Allah menjaga keistiqamahan Anda.",
    "en": "You have worshipped for {n} consecutive days. May Allah preserve your istiqamah.",
    "ar": "لقد تعبدت {n} أيام متتالية. نسأل الله أن يثبتك على الاستقامة.",
    "fr": "Vous avez adoré Allah pendant {n} jours consécutifs. Qu'Allah préserve votre istiqamah.",
    "de": "Sie haben {n} aufeinanderfolgende Tage lang angebetet. Möge Allah Ihre Istiqamah bewahren.",
    "es": "Has adorado durante {n} días consecutivos. Que Allah preserve tu istiqamah.",
    "ru": "Вы совершали поклонение {n} дней подряд. Да сохранит Аллах вашу истикаму.",
    "zh": "您已连续 {n} 天礼拜。愿安拉保佑您持守伊斯提卡迈（坚守正道）。",
    "ja": "あなたは{n}日連続で礼拝を続けました。アッラーがあなたのイスティカーマを守られますように。",
    "ko": "{n}일 연속으로 예배를 드렸습니다. 알라께서 당신의 이스티카마를 지켜 주시길 바랍니다.",
    "hi": "आपने {n} लगातार दिनों तक इबादत की। अल्लाह आपकी इस्तिक़ामत को बनाए रखे।"
  },
  "badgeShareText": {
    "id": "Alhamdulillah, saya meraih Lencana Konsistensi {n} Hari di Manasik — {n} hari berturut-turut beribadah ✔ Semoga Allah menjaga keistiqamahan kita.",
    "en": "Alhamdulillah, I have earned the {n}-Day Consistency Badge on Manasik — {n} consecutive days of worship ✔ May Allah preserve our steadfastness.",
    "ar": "الحمد لله، لقد حصلت على شارة الاتساق لـ {n} يومًا في تطبيق مناسك — {n} أيام متتالية من العبادة ✔ اللهم ثبّت قلوبنا على طاعتك.",
    "fr": "Alhamdulillah, j'ai obtenu le Badge de Constance de {n} Jours sur Manasik — {n} jours consécutifs d'adoration ✔ Qu'Allah préserve notre persévérance.",
    "de": "Alhamdulillah, ich habe das {n}-Tage-Konsistenz-Abzeichen auf Manasik verdient — {n} aufeinanderfolgende Tage der Ibadah ✔ Möge Allah unsere Beständigkeit bewahren.",
    "es": "Alhamdulillah, he obtenido la Insignia de Consistencia de {n} Días en Manasik — {n} días consecutivos de adoración ✔ Que Allah preserve nuestra perseverancia.",
    "ru": "Альхамдулиллях, я получил значок постоянства за {n} дней в Manasik — {n} дней непрерывного поклонения ✔ Да сохранит Аллах нашу стойкость.",
    "zh": "阿勒罕杜里拉，我在Manasik获得了{n}天坚持徽章 — 连续{n}天坚持功修 ✔ 愿安拉保佑我们持之以恒。",
    "ja": "アルハムドゥリッラー、Manasikで{n}日間継続バッジを獲得しました — {n}日間連続でイバーダーを続けました ✔ アッラーが私たちの堅固さを守ってくださいますように。",
    "ko": "알함두릴라, Manasik에서 {n}일 연속 뱃지를 획득했습니다 — {n}일 연속 이바다 ✔ 알라께서 우리의 굳건함을 지켜주시길 바랍니다.",
    "hi": "अलहम्दुलिल्लाह, मैंने Manasik पर {n}-दिन की कंसिस्टेंसी बैज अर्जित की — {n} लगातार दिनों की इबादत ✔ अल्लाह हमारी इस्तिक़ामत को बनाए रखे।"
  },
  "badgeView": {
    "id": "Lihat lencana",
    "en": "View Badge",
    "ar": "عرض الشارة",
    "fr": "Voir le badge",
    "de": "Abzeichen ansehen",
    "es": "Ver insignia",
    "ru": "Просмотреть значок",
    "zh": "查看徽章",
    "ja": "バッジを見る",
    "ko": "뱃지 보기",
    "hi": "बैज देखें"
  },
  "close": {
    "id": "Tutup",
    "en": "Close",
    "ar": "إغلاق",
    "fr": "Fermer",
    "de": "Schließen",
    "es": "Cerrar",
    "ru": "Закрыть",
    "zh": "关闭",
    "ja": "閉じる",
    "ko": "닫기",
    "hi": "बंद करें"
  },
  "badgeCardSub": {
    "id": "{n} Hari Berturut-turut",
    "en": "{n} Consecutive Days",
    "ar": "{n} أيام متتالية",
    "fr": "{n} jours consécutifs",
    "de": "{n} aufeinanderfolgende Tage",
    "es": "{n} días consecutivos",
    "ru": "{n} дней подряд",
    "zh": "连续{n}天",
    "ja": "{n}日間連続",
    "ko": "{n}일 연속",
    "hi": "{n} लगातार दिन"
  },
  "badgeRemaining": {
    "id": "{n} hari lagi",
    "en": "{n} days remaining",
    "ar": "{n} أيام متبقية",
    "fr": "{n} jours restants",
    "de": "Noch {n} Tage",
    "es": "{n} días restantes",
    "ru": "Осталось {n} дней",
    "zh": "还剩{n}天",
    "ja": "残り{n}日",
    "ko": "{n}일 남음",
    "hi": "{n} दिन शेष"
  }
};
